import { RootState } from 'app/store/rootReducer';

export const getPromotion = (state: RootState) => state.promotion;
